"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildOptions = void 0;
var mini_kit_1 = require("@celo/contractkit/lib/mini-kit");
var wallet_walletconnect_v1_1 = require("@celo/wallet-walletconnect-v1");
var bignumber_js_1 = require("bignumber.js");
var constants_1 = require("../constants");
var logger_1 = require("../utils/logger");
var common_1 = require("./common");
function buildOptions(network) {
  return {
    connect: {
      chainId: network.chainId
    }
  };
}
exports.buildOptions = buildOptions;
var WalletConnectConnector = /*#__PURE__*/function (_common_1$AbstractCon) {
  _inherits(WalletConnectConnector, _common_1$AbstractCon);
  function WalletConnectConnector(network, manualNetworkMode, feeCurrency,
  // options: WalletConnectWalletOptions | WalletConnectWalletOptionsV1,
  options) {
    var _this;
    var autoOpen = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var getDeeplinkUrl = arguments.length > 5 ? arguments[5] : undefined;
    var version = arguments.length > 6 ? arguments[6] : undefined;
    var walletId = arguments.length > 7 ? arguments[7] : undefined;
    _classCallCheck(this, WalletConnectConnector);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(WalletConnectConnector).call(this));
    _this.network = network;
    _this.feeCurrency = feeCurrency;
    _this.options = options;
    _this.autoOpen = autoOpen;
    _this.getDeeplinkUrl = getDeeplinkUrl;
    _this.version = version;
    _this.walletId = walletId;
    _this.initialised = false;
    _this.type = constants_1.WalletTypes.WalletConnect;
    _this.updateFeeCurrency = common_1.updateFeeCurrency.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    var wallet = new wallet_walletconnect_v1_1.WalletConnectWallet(manualNetworkMode ? {
      init: options.init,
      connect: Object.assign(Object.assign({}, options.connect), {
        chainId: undefined
      })
    } : options);
    _this.kit = (0, mini_kit_1.newKit)(network.rpcUrl, wallet);
    return _this;
  }
  // this is called automatically and is what gives us the uri for the qr code to be scanned
  _createClass(WalletConnectConnector, [{
    key: "initialise",
    value: function initialise() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var wallet, _wallet$getAccounts, _wallet$getAccounts2, address, defaultAccount;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              wallet = this.kit.getWallet();
              wallet.onSessionCreated = this.onSessionCreated.bind(this);
              wallet.onSessionUpdated = this.onSessionUpdated.bind(this);
              wallet.onCallRequest = this.onCallRequest.bind(this);
              wallet.onWcSessionUpdate = this.onWcSessionUpdate.bind(this);
              wallet.onSessionDeleted = this.onSessionDeleted.bind(this);
              // must be called after all callbacks are set
              _context.next = 8;
              return wallet.setupClient();
            case 8:
              _context.next = 10;
              return this.handleUri(wallet);
            case 10:
              _context.next = 12;
              return wallet.init();
            case 12:
              _wallet$getAccounts = wallet.getAccounts(), _wallet$getAccounts2 = _slicedToArray(_wallet$getAccounts, 1), address = _wallet$getAccounts2[0];
              _context.next = 15;
              return this.fetchWalletAddressForAccount(address);
            case 15:
              defaultAccount = _context.sent;
              this.kit.connection.defaultAccount = defaultAccount;
              this.initialised = true;
              this.emit(common_1.ConnectorEvents.WC_INITIALISED);
              return _context.abrupt("return", this);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "handleUri",
    value: function handleUri(wallet) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var uri, deepLink;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return wallet.getUri();
            case 2:
              uri = _context2.sent;
              if (uri) {
                this.emit(common_1.ConnectorEvents.WC_URI_RECEIVED, uri);
              }
              if (uri && this.autoOpen) {
                deepLink = this.getDeeplinkUrl ? this.getDeeplinkUrl(uri) : uri;
                if (deepLink) {
                  location.href = deepLink;
                }
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "startNetworkChangeFromApp",
    value: function startNetworkChangeFromApp(network) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var wallet, resp;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              wallet = this.kit.getWallet(); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              _context3.next = 4;
              return wallet.switchToChain(Object.assign(Object.assign({}, network), {
                networkId: network.chainId
              }));
            case 4:
              resp = _context3.sent;
              (0, logger_1.getApplicationLogger)().debug('[startNetworkChangeFromApp] response', resp);
              this.restartKit(network);
              this.emit(common_1.ConnectorEvents.NETWORK_CHANGED, network.name);
              _context3.next = 13;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              this.emit(common_1.ConnectorEvents.NETWORK_CHANGE_FAILED, _context3.t0);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 10]]);
      }));
    }
  }, {
    key: "restartKit",
    value: function restartKit(network) {
      var wallet = this.kit.getWallet();
      this.network = network; // must set to prevent loop
      try {
        this.kit.connection.stop(); // this blows up if its already stopped
      } finally {
        this.kit = (0, mini_kit_1.newKit)(network.rpcUrl, wallet);
      }
    }
  }, {
    key: "onSessionCreated",
    value: function onSessionCreated(error, session) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this2 = this;
        var connectSession;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (error) {
                (0, logger_1.getApplicationLogger)().error('[wallet-connect] Error while connecting', error.name, error.message);
                this.emit(common_1.ConnectorEvents.WC_ERROR, error);
              }
              connectSession = session;
              _context4.next = 4;
              return this.onConnected(connectSession).catch(function (e) {
                _this2.emit(common_1.ConnectorEvents.WC_ERROR, e);
                (0, logger_1.getApplicationLogger)().error('wallet-connect', 'onSessionCreated', 'error', e);
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "onCallRequest",
    value: function onCallRequest(error, payload) {
      (0, logger_1.getApplicationLogger)().debug('wallet-connect', 'onCallRequest', payload, error ? "Error ".concat(error.name, " ").concat(error.message) : '');
      if (error) {
        this.emit(common_1.ConnectorEvents.WC_ERROR, error);
      }
    }
  }, {
    key: "onWcSessionUpdate",
    value: function onWcSessionUpdate(_error, session) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var params;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              (0, logger_1.getApplicationLogger)().debug('wallet-connect', 'on-wc-session-update', session, _error);
              params = session.params[0];
              _context5.next = 4;
              return this.combinedSessionUpdater(params);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "onSessionUpdated",
    value: function onSessionUpdated(error, session) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var params;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              (0, logger_1.getApplicationLogger)().debug('wallet-connect', 'on-session-update', session, error);
              params = session.params[0];
              if (error) {
                this.emit(common_1.ConnectorEvents.WC_ERROR, error);
              }
              _context6.prev = 3;
              _context6.next = 6;
              return this.combinedSessionUpdater(params);
            case 6:
              _context6.next = 12;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](3);
              (0, logger_1.getApplicationLogger)().error('wallet-connect', 'on-session-update', _context6.t0);
              this.emit(common_1.ConnectorEvents.WC_ERROR, _context6.t0);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 8]]);
      }));
    }
  }, {
    key: "onSessionDeleted",
    value: function onSessionDeleted(_error, session) {
      var _a, _b;
      (0, logger_1.getApplicationLogger)().debug('wallet-connect', 'on-session-delete', session, _error);
      // since dapps send the both when they initiate disconnection and when responding to disconnection requests
      // check if dapp initiated the closure to avoid closing twice.
      if ((_b = (_a = session.params[0]) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.startsWith(END_MESSAGE)) {
        return;
      }
      void this.close();
    }
  }, {
    key: "combinedSessionUpdater",
    value: function combinedSessionUpdater(params) {
      if (params.chainId == null) {
        return this.close();
      }
      if (params.chainId !== this.network.chainId) {
        return this.emit(common_1.ConnectorEvents.WALLET_CHAIN_CHANGED, params.chainId);
      }
      var accounts = params.accounts;
      var addressFromSessionUpdate = accounts[0];
      if (typeof addressFromSessionUpdate === 'string' && addressFromSessionUpdate !== this.kit.connection.defaultAccount) {
        return this.onAddressChange(addressFromSessionUpdate);
      }
    } // for when the wallet is already on the desired network and the kit / dapp need to catch up.
  }, {
    key: "continueNetworkUpdateFromWallet",
    value: function continueNetworkUpdateFromWallet(network) {
      this.restartKit(network);
      this.emit(common_1.ConnectorEvents.NETWORK_CHANGED, network.name);
    }
  }, {
    key: "supportsFeeCurrency",
    value: function supportsFeeCurrency() {
      // If on WC 1 it will not work due to fields being dropped
      if (!this.version || this.version === 1) {
        return false;
      }
      // TODO when V2 is used again check based on wallet?
      return true;
    }
  }, {
    key: "onAddressChange",
    value: function onAddressChange(address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.fetchWalletAddressForAccount(address);
            case 2:
              this.kit.connection.defaultAccount = _context7.sent;
              this.emit(common_1.ConnectorEvents.ADDRESS_CHANGED, address);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "onConnected",
    value: function onConnected(session) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var sessionAccount, walletAddress;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              sessionAccount = session.params[0].accounts[0];
              _context8.next = 3;
              return this.fetchWalletAddressForAccount(sessionAccount);
            case 3:
              walletAddress = _context8.sent;
              if (this.kit.connection.defaultAccount !== walletAddress) {
                this.kit.connection.defaultAccount = walletAddress;
              }
              this.emit(common_1.ConnectorEvents.CONNECTED, {
                walletType: this.type,
                walletId: this.walletId,
                walletChainId: session.params[0].chainId,
                networkName: this.network.name,
                address: sessionAccount
              });
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "fetchWalletAddressForAccount",
    value: function fetchWalletAddressForAccount(address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var accounts, walletAddress;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (address) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return", undefined);
            case 2:
              _context9.next = 4;
              return this.kit.contracts.getAccounts();
            case 4:
              accounts = _context9.sent;
              _context9.next = 7;
              return accounts.getWalletAddress(address);
            case 7:
              walletAddress = _context9.sent;
              return _context9.abrupt("return", new bignumber_js_1.BigNumber(walletAddress).isZero() ? address : walletAddress);
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "close",
    value: function close(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var wallet;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              (0, logger_1.getApplicationLogger)().log('wallet-connect', 'close', message);
              _context10.prev = 1;
              wallet = this.kit.getWallet();
              _context10.next = 5;
              return wallet.close("".concat(END_MESSAGE, " : ").concat(message || ''));
            case 5:
              this.kit.connection.stop();
            case 6:
              _context10.prev = 6;
              this.disconnect();
              return _context10.finish(6);
            case 9:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[1,, 6, 9]]);
      }));
    }
  }]);
  return WalletConnectConnector;
}(common_1.AbstractConnector);
exports.default = WalletConnectConnector;
var END_MESSAGE = '[react-celo] WC SESSION ENDED BY DAPP';